function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.117,
  height: 20,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "user",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "user-2",
  "data-name": "user"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_20",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 20",
  transform: "translate(0 10.026)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_19",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 19"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 7",
  d: "M20.887,257.323a9.57,9.57,0,0,0-9.559,9.559.416.416,0,0,0,.831,0,8.727,8.727,0,0,1,17.455,0,.416.416,0,0,0,.831,0A9.569,9.569,0,0,0,20.887,257.323Z",
  transform: "translate(-11.328 -257.323)",
  fill: "#66c3d0"
}))), /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_22",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 22",
  transform: "translate(4.987)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_21",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 21"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 8",
  d: "M143.9,0a4.572,4.572,0,1,0,4.572,4.572A4.577,4.577,0,0,0,143.9,0Zm0,8.312a3.74,3.74,0,1,1,3.74-3.74A3.745,3.745,0,0,1,143.9,8.312Z",
  transform: "translate(-139.328)",
  fill: "#66c3d0"
})))));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.117,
    height: 20,
    viewBox: "0 0 19.117 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.cc9685a1.svg";
export { ForwardRef as ReactComponent };